import { render, staticRenderFns } from "./BlockMultiWave.vue?vue&type=template&id=334d1945"
import script from "./BlockMultiWave.vue?vue&type=script&lang=js"
export * from "./BlockMultiWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports